<template>
  <v-app id="ib-app">
    <!-- Authenticated with community: sidebar + content -->
    <div v-if="isAuthenticated && hasCommunity" class="ib-layout">
      <IBSidebar
        @quit-communities="goToCommunities"
      />
      <div class="ib-content">
        <router-view />
      </div>
    </div>

    <!-- Public / no community: full-width -->
    <div v-else class="ib-public">
      <router-view />
    </div>
  </v-app>
</template>

<script>
import IBSidebar from './components/IBSidebar.vue'
import brandingService from './services/branding.service'
import ClubRepository from '@/repositories/club'

export default {
  name: 'IBApp',
  components: { IBSidebar },

  data() {
    return {
      brandingLoaded: false
    }
  },

  computed: {
    isAuthenticated() {
      return !!this.$store.state.token && this.$store.state.user.id !== 0
    },
    hasCommunity() {
      return this.$store.getters['ib/hasCommunity']
    }
  },

  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        this.loadUserCommunities()
      }
    }
  },

  async created() {
    // Load partner branding
    const partnerKey = process.env.VUE_APP_IB_PARTNER_KEY
    await brandingService.loadPartnerBranding(partnerKey, this.$vuetify)
    this.brandingLoaded = true

    // If already authenticated, load communities
    if (this.isAuthenticated) {
      await this.loadUserCommunities()

      // Re-fetch data if community was restored from persisted state
      if (this.hasCommunity) {
        const clubId = this.$store.getters['ib/activeCommunity'].id
        this.$store.dispatch('ib/fetchMemberCount', clubId)
        this.$store.dispatch('ib/fetchCommunitySponsor', clubId)
      }
    }
  },

  methods: {
    async loadUserCommunities() {
      try {
        const response = await ClubRepository.allClubsOfUser()
        if (response.status < 400 && response.data) {
          this.$store.dispatch('ib/setUserCommunities', response.data)

          // Auto-select if only one community
          if (response.data.length === 1 && !this.hasCommunity) {
            const membership = response.data[0]
            this.$store.dispatch('ib/selectCommunity', {
              community: membership.club,
              membership: { id: membership.id, rol: membership.rol }
            })
            // Also set clubMember in global store for reused components
            this.$store.commit('setClubMember', membership)
          }
        }
      } catch (error) {
        console.error('[IB App] Failed to load communities:', error)
      }
    },

    goToCommunities() {
      this.$store.dispatch('ib/quitCommunity')
      this.$router.push('/communities')
    },

    logout() {
      this.$store.dispatch('ib/logout')
      this.$store.commit('clearData')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
#ib-app {
  font-family: 'Avenir', sans-serif;
  background: #F8F8F8;
}

.ib-layout {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

.ib-content {
  flex: 1;
  min-width: 0;
  padding: 40px;
  background: #F8F8F8;
  overflow-y: auto;
}

.ib-public {
  width: 100%;
  min-height: 100vh;
}

// Responsive
@media (max-width: 960px) {
  .ib-content {
    padding: 16px;
  }
}
</style>
